import React, { Component } from 'react';
import './select-next.css';

class SelectNext extends Component {
  render() {
    return (
      <div className="select-next-content-container">
        <div className="select-next-content" onClick={this.props.slidePrev}>
          <i className="ui icon angle left" />
        </div>
        <div className="select-next-content" onClick={this.props.slideNext}>
          <i className="ui icon angle right" />
        </div>
      </div>
    );
  }
}

export default SelectNext;



// WEBPACK FOOTER //
// ./src/components/select-content/select-next/index.js